export const BASE_URL = window.FZ_API_BASE_URL;

export type BankInfo = {
  inn: string;
  name: string;
};

export type SelectBankInfo = BankInfo & {
  terms: {
    result: boolean;
    law: boolean;
    bgType: boolean;
    bgAmount: boolean;
    duration: false,
    bgPrincipalOkved: boolean;
    bgPrincipalRegion: boolean;
    bgBeneficiaryOkved: boolean;
    bgBeneficiaryRegion: boolean;
  }
};

export type BankSelectProps = Partial<{
  principalInn: string;
  beneficiaryInn: string;
  law: string;
  duration: number;
  bgAmount: number;
  bgType: string;
}>

export async function fetchBanks(
  accessToken?: string
): Promise<BankInfo[]> {
  if (!accessToken) throw new Error('Нет accessToken');

  const url = `${BASE_URL}/front-bg/bank`;
  const resp = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });
  if (!resp.ok) throw new Error('HTTP ' + resp.status);

  const data: BankInfo[] = await resp.json();
  return data;
}

export async function selectBanks(
  body: BankSelectProps,
  accessToken: string
): Promise<SelectBankInfo[]> {
  const url = `${BASE_URL}/front-bg/bank/select`;
  const resp = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(body)
  });
  if (!resp.ok) throw new Error('HTTP ' + resp.status);

  const data: SelectBankInfo[] = await resp.json();
  return data;
}
